import { UserInitData } from '@/logic/main/types';
import { saveUserInitData } from '@/model/tracking';
import Cookie from '@/ports-frontend/Cookie';

export const initializeTrackingData = async () => {
  const CustomerAccountNumber = (await Cookie.get('trk_uid')) || null;
  const CurrencyCode = (await Cookie.get('trk_curc')) || null;
  const UserStatus = CustomerAccountNumber ? 'Customer' : 'Non-Customer';

  const userData: UserInitData = {
    CustomerAccountNumber,
    CurrencyCode,
    UserStatus,
  };

  saveUserInitData(userData);
};
